<template>
  <div id="information">
    <!-- Card group -->
    <row>
    <div class="card-deck">

      <!-- Card -->
      <div class="card mb-4">

        <!-- Card image -->
        <div class="view overlay" @click="showModal = true">
          <img class="card-img-top" src="../assets/123.jpg" alt="Card image cap">
            <div class="mask rgba-white-slight"></div>
         </div>

        <!-- Card content -->
        <div class="card-body">

          <!-- Title -->
          <h4 class="card-title">Тонерный калькулятор</h4>
          <!-- Text -->
          <p class="card-text">Сколько нужно засыпать тонера, чтобы получить нужное число отпечатков. Или наоборот.  </p>
          <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
          <button type="button" class="btn btn-primary btn-md" @click="showModal = true">Посчитать</button>

        </div>
        <!-- Card content -->

      </div>
      <!-- Card -->

      <!-- Card -->
      <div class="card mb-4">

        <!-- Card image -->
        <div class="view overlay" @click="showModalH = true">
          <img class="card-img-top" src="../assets/Cartridges.jpg" alt="Card image cap">
          <div class="mask rgba-white-slight"></div>
        </div>

        <!-- Card content -->
        <div class="card-body">
          <!-- Title -->
          <h4 class="card-title">Тонер для HP</h4>
          <!-- Text -->
          <p class="card-text">Какой тонер лучше подходит к картриджу или принтеру HP.<br>Таблица и советы.</p>
          <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
          <button type="button" class="btn btn-primary btn-md" @click="showModalH = true">Узнать</button>

        </div>
        <!-- Card content -->

      </div>
      <!-- Card -->

      <!-- Card -->
      <div class="card mb-4">

        <!-- Card image -->
        <div class="view overlay" @click="showModalS = true">
          <img class="card-img-top" src="../assets/samsung.jpg" alt="Card image cap">
            <div class="mask rgba-white-slight"></div>
        </div>

        <!-- Card content -->
        <div class="card-body">
          <!-- Title -->
          <h4 class="card-title">Тонер для SAMSUNG</h4>
          <!-- Text -->
          <p class="card-text">Какой тонер лучше подходит к картриджу или принтеру SAMSUNG.<br>Таблица и советы.</p>
          <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
          <button type="button" class="btn btn-primary btn-md" @click="showModalS = true">Узнать</button>

        </div>
        <!-- Card content -->

      </div>
      <!-- Card -->
      <!-- Card -->
      <div class="card mb-4">

        <!-- Card image -->
        <div class="view overlay" @click=" showModalK = true">
          <img class="card-img-top" src="../assets/kyocera.jpg" alt="Card image cap">
          <div class="mask rgba-white-slight"></div>
        </div>

        <!-- Card content -->
        <div class="card-body">
          <!-- Title -->
          <h4 class="card-title">Тонер для KYOCERA</h4>
          <!-- Text -->
          <p class="card-text">Какой тонер лучше подходит к картриджу или принтеру KYOCERA.<br>Таблица и советы.</p>
          <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
          <button type="button" class="btn btn-primary btn-md" @click="showModalK = true">Узнать</button>

        </div>
        <!-- Card content -->

      </div>
      <!-- Card -->

    </div>
    <!-- Card group -->
    </row>
     <row>
    <div class="card-deck">

      <!-- Card -->
      <div class="card mb-4">

        <!-- Card image -->
        <div class="view overlay" @click="showModal = true">
          <img class="card-img-top" src="../assets/ggsm.jpg" alt="Card image cap">
            <div class="mask rgba-white-slight"></div>
         </div>

        <!-- Card content -->
        <div class="card-body">

          <!-- Title -->
          <h4 class="card-title">GoldenGreen</h4>
          <!-- Text -->
          <p class="card-text">Как отличить настоящие фотобарабаны GoldenGreen от подделки? Ищите лазерную гравировку на каждом фотобарабане!</p>
        </div>
        <!-- Card content -->

      </div>
      <!-- Card -->

      <!-- Card -->
      <div class="card mb-4">

        <!-- Card image -->
        <div class="view overlay" @click="showModalH = true">
          <img class="card-img-top" src="../assets/opcjpg.jpg" alt="Card image cap">
          <div class="mask rgba-white-slight"></div>
        </div>

        <!-- Card content -->
        <div class="card-body">
          <!-- Title -->
          <h4 class="card-title">GoldenGreen</h4>
          <!-- Text -->
          <p class="card-text">Как отличить фотобарабаны GoldenGreen стандартного ресурса от LongLife? По цвету. Сверху - LongLife, снизу стандартный.</p>
        </div>
        <!-- Card content -->

      </div>
      <!-- Card -->

    </div>
    <!-- Card group -->
    </row>
    <template>
      <container class="mt-5">
        <modal position="bottom" size="lg" v-if="showModal" @close="showModal = false">
          <modal-header>
            <modal-title>Тонерный калькулятор</modal-title>
          </modal-header>
          <modal-body>
            Можно изменять как массу тонера, так и желаемое чисто страниц
            <tbl responsive striped>
              <tbl-head color="primary-color" textWhite>
                <tr>
                  <th>Тонер</th>
                  <th>Масса, г</th>
                  <th>Ресурс, стр</th>
                </tr>
              </tbl-head>
              <tbl-body>
                <tr>
                  <th>IMEX HP MG/MGI</th>
                  <td><input type="number" v-model="MGW" @input=" calcYeildMG()"></td>
                  <td><input type="number" v-model="MGY" @input=" calcWeightMG()"></td>
                </tr>
                <tr>
                  <th>IMEX HP CMG-3</th>
                  <td><input type="number" v-model="CMGW" @input=" calcYeildCMG()"></td>
                  <td><input type="number" v-model="CMGY" @input=" calcWeightCMG()"></td>
                </tr>
                <tr>
                  <th>IMEX HP TMC-040</th>
                  <td><input type="number" v-model="TMCW" @input=" calcYeildTMC()"></td>
                  <td><input type="number" v-model="TMCY" @input=" calcWeightTMC()"></td>
                </tr>
                <tr>
                  <th>IMEX KYOCERA MSK</th>
                  <td><input type="number" v-model="MSKW" @input=" calcYeildMSK()"></td>
                  <td><input type="number" v-model="MSKY" @input=" calcWeightMSK()"></td>
                </tr>
                <tr>
                  <th>IMEX KYOCERA YFX</th>
                  <td><input type="number" v-model="YFXW" @input=" calcYeildYFX()"></td>
                  <td><input type="number" v-model="YFXY" @input=" calcWeightYFX()"></td>
                </tr>
                <tr>
                  <th>IMEX KYOCERA WS-S2</th>
                  <td><input type="number" v-model="WSW" @input=" calcYeildWS()"></td>
                  <td> <input type="number" v-model="WSY" @input=" calcWeightWS()"></td>
                </tr>
              </tbl-body>
            </tbl>
          </modal-body>
          <modal-footer>
            <btn class="btn-sm" color="primary" @click.native="showModal = false">Закрыть</btn>
          </modal-footer>
        </modal>
      </container>
    </template>
    <!-- HP -->
    <template>
      <container class="mt-5">
        <modal position="bottom" size="fluid" v-if="showModalH" @close="showModalH = false">
          <modal-header>
            <modal-title>Тонер для HP</modal-title>
          </modal-header>
          <modal-body>
            <tbl responsive striped>
              <tbl-head color="primary-color" textWhite>
                <tr>
                  <th scope="col" class="th-lg">Тонер</th>
                  <th scope="col">Тип</th>
                  <th scope="col">Совместимость</th>
                  <th scope="col">Комментарий</th>
                </tr>
              </tbl-head>
              <tbl-body>
                <tr>
                  <th>IMEX MG</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>HP LaserJet 700Pro 1010 1012 1015 1018 1020 1022 1150 1160 1300 1320 2300 2400 2410 2420 2430 4200 4250 4300 4350 5200HP P2035 2055HP M712 725 5025 5025MPF 5035 5035MPF CANON LBP3300 3410 3500 3910 3920 3930 3950 3970 3980 6300 6330 6340 6700 6710 8610 8620 8630</td>
                  <td>Сферизованный тонер по технологии IMEX SFS/MST <img src="../assets/sm.jpg" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                </tr>
                <tr>
                  <th>IPM UNIVERSAL U</th>
                  <td><img src="../assets/pulverised.png" alt="Пульверизованный" title="Пульверизованный" class="img-thumbnail"></td>
                  <td>HP LaserJet 700Pro 1010 1012 1015 1018 1020 1022 1150 1160 1300 1320 2300 2400 2410 2420 2430 4200 4250 4300 4350 5200HP P2035 2055HP M712 725 5025 5025MPF 5035 5035MPF CANON LBP3300 3410 3500 3910 3920 3930 3950 3970 3980 6300 6330 6340 6700 6710 8610 8620 8630</td>
                  <td>Молотый тонер. Превосходит китайские, индийские и малайзийские аналоги, уступает только японским тонерам. Самый черный тонер на рынке.</td>
                </tr>
                <tr>
                  <th>IPM UNIVERSAL STAR2</th>
                  <td><img src="../assets/pulverised.png" alt="Пульверизованный" title="Пульверизованный" class="img-thumbnail"></td>
                  <td>LJ 1010 1160 1320 2300 2420 2430 4200 4250 4300 4350 5200 P2035 2055 P3005 P3015 LJ700 PRO M712 725 P1005 1006 1007 M125 127 P1102 1212 1500 1505 1606 1566 2035 2055 3005 3015 M 3027 3035 Pro400 MFP M425 402 426</td>
                  <td>Молотый тонер. Наиболее универсальный тонер в линейке.</td>
                </tr>
                <tr>
                  <th>IMEX MGI</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>HP LaserJet P2010 2015 3005 3015 4014 4015 4510 4515HP LaserJet M400 401 402 601 602 603 4555HP LaserJet MPF M525 3027 3035 630DN/H</td>
                  <td>Сферизованный тонер по технологии IMEX SFS/MST. Специальный тонер для принтеров с пониженной температурой запекания</td>
                </tr>
                <tr>
                  <th>IMEX CMG-3</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>HP LaserJet P1005 1006 1102 1106 1108 1505 1522n 1560 1606HP LaserJet M12 26 125 127 128 201nHP LaserJet ProM402/MFP M426 M501 M506/MFP M527CANON LBP3100 6030 6040 6200 6230 6240CANON MF4430 4410 4420 4450 4550 4580 4820 4870 4890</td>
                  <td>Сферизованный тонер по технологии IMEX SFS/MST <img src="../assets/sm3.jpg" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                </tr>
                <tr>
                  <th>IPM HP MOON</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>HP LaserJet P1005 1006 1102 1106 1108 1505 1522n 1560 1606HP LaserJet M12 26 125 127 128 201nHP LaserJet ProM402/MFP M426 M501 M506/MFP M527CANON LBP3100 6030 6040 6200 6230 6240CANON MF4430 4410 4420 4450 4550 4580 4820 4870 4890</td>
                  <td>Сферизованный полиэстерный тонер</td>
                </tr>
                <tr>
                  <th>IMEX TMC-040</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>Все цветные, кроме HP 1500</td>
                  <td>Сферизованный тонер по технологии IMEX SFS/MST. См.детальную информацию по массе засыпки и регулировке зазора дозирующего лезвия по ссылке: <button type="button" class="btn btn-sm"><a href="https://infotronic.by/assets/files/TMC040.pdf">Перейти</a></button></td>
                </tr>
                <tr>
                <th>IPM TDH 126</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>CF217A CF230-1-2A CF233-234A</td>
                  <td>Сферизованный полиэстерный тонер</td>
                </tr>
              </tbl-body>
            </tbl>
          </modal-body>
          <modal-footer>
            <btn class="btn-sm" color="primary" @click.native="showModalH = false">Закрыть</btn>
          </modal-footer>
        </modal>
      </container>
    </template>
   <!-- HP -->
   <!-- SAMSUNG -->
    <template>
      <container class="mt-5">
        <modal position="bottom" size="fluid" v-if="showModalS" @close="showModalS = false">
          <modal-header>
            <modal-title>Тонер для SAMSUNG</modal-title>
          </modal-header>
          <modal-body>
            <tbl responsive striped>
              <tbl-head color="primary-color" textWhite>
                <tr>
                  <th scope="col" class="th-lg">Тонер</th>
                  <th scope="col">Тип</th>
                  <th scope="col">Совместимость</th>
                  <th scope="col">Комментарий</th>
                </tr>
              </tbl-head>
              <tbl-body>
                <tr>
                  <th>IPM LIZARD</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>Тонер IPM LIZARD для SAMSUNG®/ LEXMARK®/OKI ®/ XEROX®/RICOH® </td>
                  <td>Сферизованный полиэстерный тонер. Не требует предварительной очистки от остатков предыдущего тонера, прекрасно смешивается с большинством тонеров. Не подходит для Samsung D101/111. Хит продаж и лучший тонер в своем классе!</td>
                </tr>
                <tr>
                  <th>IMEX SML-2</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>MLT-D1042X MLT-D1052L MLT-D1052S MLT-D205E MLT-D205L ML-D4550A ML-D4550B</td>
                  <td>Сферизованный полиэстерный тонер по технологии IMEX SFS/MST <img src="../assets/sm3.jpg" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                </tr>
                <tr>
                  <th>MK IMAGING 19S2</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>Samsung D101/D111/ML2160/SCX3400/XEROX 3010/3045/3020/3025</td>
                  <td>Сферизованный полиэстерный тонер</td>
                </tr>
                <tr>
                  <th>IPM TDS SM73</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>Samsung ML-5510/ 6510/ Xerox Phaser 4600/4620</td>
                  <td>Двухкомпонентный тонер</td>
                </tr>
               </tbl-body>
            </tbl>
          </modal-body>
          <modal-footer>
            <btn class="btn-sm" color="primary" @click.native="showModalS = false">Закрыть</btn>
          </modal-footer>
        </modal>
      </container>
    </template>
   <!-- SAMSUNG -->
   <!-- KYOCERA -->
    <template>
      <container class="mt-5">
        <modal position="bottom" size="fluid" v-if="showModalK" @close="showModalK = false">
          <modal-header>
            <modal-title>Тонер для KYOCERA</modal-title>
          </modal-header>
          <modal-body>
            <tbl responsive striped>
              <tbl-head color="primary-color" textWhite>
                <tr>
                  <th scope="col" class="th-lg">Тонер</th>
                  <th scope="col">Тип</th>
                  <th scope="col">Совместимость</th>
                  <th scope="col">Комментарий</th>
                </tr>
              </tbl-head>
              <tbl-body>
                <tr>
                  <th>IPM SKYMOON</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>TK-3130 TK-3132 TK-3134 TK-3120 TK-3122 TK-3124 TK-3110 TK-3112 TK-3113 TK-3114 TK-3100 TK-3101 TK-3102 TK-3103 TK-3104 TK-3150 TK-1130 TK-1140 TK-1124 TK-1120 TK-1114 TK-1110 TK-450 TK-440 TK-400 TK-360 TK-350 TK-340 TK-330 TK-320 TK-310 TK-170 TK-172 TK-160 TK-162 TK-140 TK-142 TK-130 TK-132 TK-134 TK-120 TK-67 TK-65 TK-60 TK-57 TK-55 TK-50 TK-18 TK-9</td>
                  <td>Суперуниверсал. Подходит ко всем TK, кроме KYOCERA TK1110-1120. Хит продаж!</td>
                </tr>
                <tr>
                  <th>IPM SKYMOON2</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>TK-3130 TK-3132 TK-3134 TK-3120 TK-3122 TK-3124 TK-3110 TK-3112 TK-3113 TK-3114 TK-3100 TK-3101 TK-3102 TK-3103 TK-3104 TK-3150 TK-1130 TK-1140 TK-1124 TK-1120 TK-1114 TK-1110 TK-450 TK-440 TK-400 TK-360 TK-350 TK-340 TK-330 TK-320 TK-310 TK-170 TK-172 TK-160 TK-162 TK-140 TK-142 TK-130 TK-132 TK-134 TK-120 TK-67 TK-65 TK-60 TK-57 TK-55 TK-50 TK-18 TK-9</td>
                  <td>Суперуниверсал, не боится смешивания с другими тонерами. Подходит ко всем TK, кроме KYOCERA TK1110-1120. Хит продаж!</td>
                </tr>
                <tr>
                  <th>MK IMAGING 19F1</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>TK 100 TK 60 TK 300 TK 50 TK 17 TK 25 TK 18 TK 1130 TK 410 TK 1140 TK 435 TK 420 TK 20H TK 725 TK 30H TK 727 TK 70 TK 715 TK 55 TK 719 TK 65 TK 7105 TK 440 TK 7107 TK 450</td>
                  <td>Легендарный тонер от Мицубиси. Только на нем аппараты становятся миллиониками.</td>
                </tr>
                <tr>
                  <th>MK IMAGING 19F5</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>TK 1130 TK 1140 TK 1150 TK 1160 TK 1170 TK 3100 TK 3110 TK 3130 TK 3160 TK 3170 TK 3190 TK 440 TK 450</td>
                  <td>Универсальный тонер от Мицубиси для нового поколения аппаратов</td>
                </tr>
                <tr>
                  <th>IMEX MSK</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>TK-130 TK-140 TK-170 TK-340 TK-350 TK-360 TK-450 TK-710</td>
                  <td>Сферизованный полиэстерный тонер по технологии IMEX SFS/MST <img src="../assets/sm3.jpg" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                </tr>
                <tr>
                  <th>IMEX YFX</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>TK-131 TK-350 TK-475 TK-1110 TK-1111 TK-1112 TK-1115 TK-1120 TK-1125 TK-1141 TK-3100 TK-3101 TK-3102 TK-3110 TK-3112 TK-3122 TK-3130 TK-3131 TK-3132 TK-3150 TK-3160 TK-3170 TK-3190 TK-7301</td>
                  <td>Сферизованный полиэстерный тонер по технологии IMEX SFS/MST <img src="../assets/sm3.jpg" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                </tr>
                <tr>
                  <th>IPM TDKM114</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>FS 1040 1060 1025MFP 1120 1125MFP TK-1110 1114 1120</td>
                  <td>Специализированный тонер с качеством оригинала</td>
                </tr>
                <tr>
                  <th>IPM TDKM127</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>TK-1150 TK-1160 TK-1170</td>
                  <td>Специализированный тонер с качеством оригинала</td>
                </tr>
                <tr>
                  <th>IPM TDKM130</th>
                  <td><img src="../assets/spherical.png" alt="Сферический" title="Сферический" class="img-thumbnail"></td>
                  <td>TK-3160 3170 3190 P3045/3050/3055/3060dn</td>
                  <td>Специализированный тонер с качеством оригинала</td>
                </tr>
               </tbl-body>
            </tbl>
          </modal-body>
          <modal-footer>
            <btn class="btn-sm" color="primary" @click.native="showModalK = false">Закрыть</btn>
          </modal-footer>
        </modal>
      </container>
    </template>
   <!-- KYOCERA -->
  </div>
</template>

<script>
import {
  Btn,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Container,
  NumericInput,
  Row,
  Column,
  Tbl,
  TblHead,
  TblBody
} from 'mdbvue'
export default {
  name: 'Information',
  data () {
    return {
      showModal: false,
      showModalH: false,
      showModalS: false,
      showModalK: false,
      MGW: 100,
      MGY: 2272,
      TMCW: 100,
      TMCY: 7692,
      CMGW: 100,
      CMGY: 2857,
      MSKW: 100,
      MSKY: 2808,
      YFXW: 100,
      YFXY: 4065,
      WSW: 100,
      WSY: 6250
    }
  },
  methods: {
    calcWeightMG () {
      this.MGW = Math.floor(this.MGY * 44 / 1000)
    },
    calcYeildMG () {
      this.MGY = Math.floor(this.MGW / 44 * 1000)
    },
    calcWeightCMG () {
      this.CMGW = Math.floor(this.CMGY * 35 / 1000)
    },
    calcYeildCMG () {
      this.CMGY = Math.floor(this.CMGW / 35 * 1000)
    },
    calcWeightTMC () {
      this.TMCW = Math.floor(this.TMCY * 16 / 1000)
    },
    calcYeildTMC () {
      this.TMCY = Math.floor(this.TMCW / 16 * 1000)
    },
    calcWeightMSK () {
      this.MSKW = Math.floor(this.MSKY * 35.6 / 1000)
    },
    calcYeildMSK () {
      this.MSKY = Math.floor(this.MSKW / 35.6 * 1000)
    },
    calcWeightYFX () {
      this.YFXW = Math.floor(this.YFXY * 24.6 / 1000)
    },
    calcYeildYFX () {
      this.YFXY = Math.floor(this.YFXW / 24.6 * 1000)
    },
    calcWeightWS () {
      this.WSW = Math.floor(this.WSY * 16 / 1000)
    },
    calcYeildWS () {
      this.WSY = Math.floor(this.WSW / 16 * 1000)
    }
  },
  components: {
    Btn,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Container,
    NumericInput,
    Row,
    Column,
    Tbl,
    TblHead,
    TblBody
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Information.vue